import React, { Component } from "react";
import SimpleHeader from "../../base/features/blocks/SimpleHeader";
import { apiService } from "../../base/utils/service";
import DynamicView from "../dynamicView/DynamicView";
import Spinner from "../../base/features/micro/Spinner";

class DynamicPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageId:
        window.location.pathname.split("/").length === 5
          ? window.location.pathname.split("/")[4]
          : window.location.pathname.split("/").length === 4
          ? window.location.pathname.split("/")[3]
          : window.location.pathname.split("/")[2],
      views: null,
      title: "",
    };
  }
  componentDidMount() {
    console.log(window.location.pathname.split("/").length);
    this.getPageView();
  }
  getPageView() {
    apiService(`v1/pages/${this.state.pageId}`, "get").then((data) => {
      if (data) {
        this.setState({
          views: data.views,
          showSearch: data.show_search,
          title: data.title,
        });
      }
    });
  }
  render() {
    return (
      <div className="container-fluid px-0">
        <SimpleHeader text={this.state.title} />
        <div style={{ marginBottom: "100px", marginTop: "80px" }}>
          {this.state.views ? (
            <DynamicView viewPage="page" views={this.state.views} />
          ) : (
            <div>
              <Spinner />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default DynamicPage;
